import request from '@/utils/request'

export function pageAccountsReceivableSummaryReport (params) {
  return request({
    url: '/erp/finance/report/accounts-receivable-summary/page',
    method: 'get',
    params
  })
}

export function listAccountsReceivableSummaryCustomerOptions () {
  return request({
    url: '/erp/finance/report/accounts-receivable-summary/customer-options',
    method: 'get'
  })
}

export function exportAccountsReceivableSummaryReport (params) {
  return request({
    url: '/erp/finance/report/accounts-receivable-summary/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}
